import {
  AdminRoutePath,
  MainRoutePath,
} from 'applications/GSP/shared/constants/router';
import { useStudent, useUserRole } from 'applications/GSP/shared/hooks/user';
import { UserRole } from 'applications/GSP/shared/types';

export const useGetHomePageRoutePath = () => {
  const role = useUserRole();
  const student = useStudent();

  if (role === UserRole.NonTeachingStaff) {
    return AdminRoutePath.AdminSchoolLinks;
  }

  if ((role === UserRole.Admin || role === UserRole.Staff) && !student) {
    return AdminRoutePath.StudentObserver;
  }

  return MainRoutePath.Dashboard;
};
